/*
 * @description:
 * @Author: liwg
 * @Date: 2022-06-12 10:45:07
 * @LastEditors: liwg
 * @LastEditTime: 2022-11-18 09:44:56
 */

import type { CompareFaceParams, InfoData, UploadMonitorImageParams, UserInfo } from './type'

enum Api {
  UpdateInfo = '/ns-service-app-evaluation/account/update',
  QueryInfo = '/ns-service-app-evaluation/account/queryAccount',
  QueryActiInfo = '/ns-service-app-evaluation/account/queryInfoByActiId',
  QueryDictCodes = '/ns-service-app-system/sysDict/queryDictCodes',
  QuerySysRegion = '/ns-service-app-system/sysRegion/queryTree',
  UploadPhoto = '/ns-service-app-evaluation/accountTestPhoto/uploadPhoto',
  CompareFace = '/ns-service-app-evaluation/accountTestPhoto/compareFace',
  QueryIdPhoto = '/ns-service-app-calcul/accountTestPhoto/queryIdPhoto',
  SendFaceFail = '/ns-service-app-evaluation/accountTestPhoto/sendFaceFail',
  QueryPersonDefaultImage = '/ns-service-app-user/account/queryHrcPhotoByEmpId',
  QueryAliStsTempToken = '/ns-service-app-calcul/accountTestPhoto/queryAliStsTempToken',
  SavePhotoUrl = '/ns-service-app-calcul/accountTestPhoto/save',
  NewCompareFace = '/ns-service-app-calcul/accountTestPhoto/compareFace'
}

export function updateInfo(params: any) {
  return http.post<any>({
    url: Api.UpdateInfo,
    data: params
  })
}

export function queryInfo() {
  return http.post<UserInfo>({
    url: Api.QueryInfo
  })
}

export function queryActiInfo(id: number) {
  return http.post<InfoData>({
    url: Api.QueryActiInfo,
    data: {
      ocActiId: id
    }
  })
}

export const getDictByCodes = async (codes: string[]) => {
  return http.post({
    url: Api.QueryDictCodes,
    data: { codes }
  })
}

export const getSysRegion = () => {
  return http.post({
    url: Api.QuerySysRegion
  })
}

export const uploadMonitorImage = (params: UploadMonitorImageParams) => {
  return http.uploadFile(
    {
      url: Api.UploadPhoto
    },
    params
  )
}

export const compareFace = (params: CompareFaceParams) => {
  return http.uploadFile(
    {
      url: Api.CompareFace
    },
    params
  )
}

export const newCompareFace = (params: any) => {
  return http.post(
    {
      url: Api.NewCompareFace,
      data: params
    },
    {
      errorMessageMode: 'none'
    }
  )
}

export const queryIdPhoto = (params: { actiId: number }) => {
  return http.post({
    url: Api.QueryIdPhoto,
    data: params
  })
}

export const queryPersonDefaultImage = (params: { staffCode: number | string }) => {
  return http.post({
    url: Api.QueryPersonDefaultImage,
    data: params
  })
}

export const sendFaceFail = (params: { actiLinkId: number }) => {
  return http.post({
    url: Api.SendFaceFail,
    data: params
  })
}

export const queryAliStsTempToken = () => {
  return http.post(
    {
      url: Api.QueryAliStsTempToken
    },
    {
      errorMessageMode: 'none'
    }
  )
}

export const savePhotoUrl = (params: {
  actiId: string | number
  actiLinkId: string | number
  accountId: string | number
  url: string
  photoType: string
  answerId?: string | number
}) => {
  return http.post(
    {
      url: Api.SavePhotoUrl,
      data: params
    },
    {
      errorMessageMode: 'none'
    }
  )
}
